import Image from "next/image";
import { useEffect } from "react";
const Industry = (props) => {
  const removeBackground = () => {
    let element = document.getElementById("dynamic-menu-image-section");
    element.classList.remove("bg-blue-500");
  };

  return (
    <div
      onMouseEnter={removeBackground}
      className="flex w-full bg-blue-500"
      id="industry"
    >
      <div className="flex flex-col lg:flex-row mx-5 xl:mx-28 py-10 md:py-24 justify-between lg:gap-24">
        <div className="basis-1/2 flex lg:items-center pb-10 lg:pb-0">
          <span className="text-white font-headline font-extrabold text-5xl lg:text-6xl xl:text-8xl">
            Industries Served
          </span>
        </div>
        <div className="basis-1/2  flex flex-col md:flex-row  w-full lg:gap-16">
          <div className="flex">
            <ul className="flex flex-col">
              <li className="pb-4 md:pb-9 flex items-center">
                <div className="block">
                 <img src="/images/VLSI/landing/GeneralComputing-8.png" className="h-10 md:h-20 md:w-20"/>
                </div>

                <p className="text-white font-extrabold text-2xl md:text-3xl pl-6">
                  General Computing
                </p>
              </li>
              <li className="pb-4 md:pb-9 flex items-center">
                <div className="block">
                <img src="/images/VLSI/landing/Automotive-8.png" className="h-10 md:h-20 md:w-20"/>
                </div>

      
                <p className="text-white font-extrabold text-2xl md:text-3xl pl-6">
                  Automotive
                </p>
              </li>
              <li className="pb-4 md:pb-9 flex items-center">
                <div className="shrink-0 block">
              <img src="/images/VLSI/landing/Telecommunications-8.png" className=" md:w-20 h-10 md:h-20"/>
                </div>
                <p className="text-white font-extrabold text-2xl md:text-3xl pl-6">
                  Telecommunications
                </p>
              </li>
            </ul>
          </div>
          <div className="flex">
            <ul className="flex flex-col">
              <li className="pb-4 md:pb-9 flex items-center">
                <div className="block">
                <img src="/images/VLSI/landing/IoT-8.png" className="md:w-20 h-10 md:h-20"/>
                </div>

         
                <p className="text-white font-extrabold text-2xl md:text-3xl pl-6">
                  IoT
                </p>
              </li>
              <li className="pb-4 md:pb-9 flex items-center">
                <div className="shrink-0 block">
               <img src="/images/VLSI/landing/ArtificialIntelligence-8.png"  className="h-10 md:h-20 md:w-20"/>
                </div>

               
                <p className="text-white font-extrabold text-2xl md:text-3xl pl-6">
                  Artificial Intelligence
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Industry;
